import React, { useEffect, useState } from "react";

const KEY = "scitus.cookie-consent";

export const CookieBanner = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        try {
            const stored = window.localStorage.getItem(KEY);
            if (!stored) setShow(true);
        } catch {
            /* ignore */
        }
    }, []);

    const handle = (choice) => {
        try {
            window.localStorage.setItem(KEY, JSON.stringify({ choice, ts: Date.now() }));
        } catch {
            /* ignore */
        }
        setShow(false);
    };

    if (!show) return null;

    return (
        <div className="cookie-banner" role="dialog" aria-label="Cookie preferences" data-testid="cookie-banner">
            <div className="container cookie-inner">
                <div className="cookie-text">
                    <strong>We use a small number of cookies</strong>
                    <p className="muted" style={{ margin: "4px 0 0 0", fontSize: "0.88rem" }}>
                        Essential cookies keep the site working. We&apos;d like to load privacy-friendly analytics to learn what&apos;s useful. Your call — change it anytime.
                    </p>
                </div>
                <div className="cookie-actions">
                    <button type="button" className="btn btn-ghost btn-sm" onClick={() => handle("reject")} data-testid="cookie-reject">
                        Essential only
                    </button>
                    <button type="button" className="btn btn-primary btn-sm" onClick={() => handle("accept")} data-testid="cookie-accept">
                        Accept all
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
